






















import { Component, Vue } from "vue-property-decorator";
import {
  COLOR_VIEW_AS_USER_HIGHLIGHT,
  COLOR_VIEW_AS_USER_HIGHLIGHT_DARK,
  COLOR_VIEW_AS_USER_HIGHLIGHT_TEXT,
} from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { endViewAs, getViewAsUser } from "@/utils/ViewAs";

/**
 * The "Sicht auf: <name>" chip (ticket 2610050): small and pale on purpose, and a click on it ends
 * "Sicht auf" (Taimoor, 2026-10-14: no ✕, no menu). It sits at the end of whatever the app bar shows
 * on the left: after the page title (Scaffold), or after the Cockpit's header context (CompanyHeader).
 * Rules: docs/users/view-as.md.
 */
@Component
export default class ViewAsChipComponent extends Vue {
  get viewAsUser() {
    return getViewAsUser();
  }

  get label() {
    const viewAsUser = this.viewAsUser;

    return viewAsUser ? this.$t("common.viewOf", [viewAsUser.nickname]).toString() : "";
  }

  /** Dark mode outlines the chip instead of filling it (see `COLOR_VIEW_AS_USER_HIGHLIGHT_DARK`). */
  get isDark() {
    return this.$vuetify.theme.dark;
  }

  /** Pale cream fill; in dark mode the colour of the outline and the label. */
  get chipColor() {
    return themed(COLOR_VIEW_AS_USER_HIGHLIGHT, COLOR_VIEW_AS_USER_HIGHLIGHT_DARK);
  }

  /** An outlined chip takes its label colour from `color`. */
  get chipTextColor() {
    return this.isDark ? undefined : COLOR_VIEW_AS_USER_HIGHLIGHT_TEXT;
  }

  onEndViewAs() {
    endViewAs();
  }
}
